import React from 'react';

import './text.css';

export const Fonts = {
  Fancy: 'font--fancy',
};
